export default __webpack_public_path__ + "static/noi2020bronze-e213e8c16aeddd66af98d66e2254dc35.png";